<template>
  <layout-editor-page
    :title="formTitle"
    isTabsPage
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <el-tabs v-model="activeTab">
      <el-tab-pane name="general">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('general')}}</span>
        </template>
        <layout-scroll-content>
          <form-general
            :disabled="disabled"
            ref="Form"
            :data="data"
            :model="formModel"
            @updateModelItem="handlerUpdateModelItem"
            @change="handleFormData"/>
          <template v-slot:footer>
            <form-controls
              class="form-footer"
              :isCreate="!hasCreateNew && !disabled"
              :isSave="hasCreateNew && !disabled"
              :isDelete="hasCreateNew && !disabled"
              @command="setCommand"/>
          </template>
        </layout-scroll-content>
      </el-tab-pane>
      <el-tab-pane name="parts" :disabled="!hasCreateNew">
        <template v-slot:label>
          <span class="el-tabs__custom-label">{{L10n('parts')}}</span>
        </template>
        <parts-list-grid
          ref="parts-list-grid"
          :aircraftID="this.currentID"
        />
      </el-tab-pane>
    </el-tabs>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import FormWrapperAutoSave from '@/components/Form/FormWrapperAutoSave'

export default {
  name: 'EditorAircrafts',
  mixins: [FormWrapper, FormWrapperAutoSave],
  components: {
    'layout-scroll-content': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/EditorPage/ScrollContent.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls'),
    'form-general': () => import(/* webpackChunkName: 'Aircrafts' */ './FormGeneral'),
    'parts-list-grid': () => import(/* webpackChunkName: 'Aircrafts' */ './PartsAircraft/Index.vue')
  },
  computed: {
    formTitle () {
      return this.formData.aircraftModel
    }
  },
  data: () => ({
    activeTab: 'general',
    // eslint-disable-next-line
    apiPatch: 'Aircrafts/Patch/${data.id}'
  }),
  methods: {
    formModel () {
      return {
        id: '',
        aircraftModel: '',
        aircraftSeries: '',
        aircraftManufacturer: '',
        aircraftEngineModel: '',
        aircraftEngineSeries: ''
      }
    }
  }
}
</script>
